import(/* webpackMode: "eager" */ "/vercel/path0/src/sections/account/view/user-account-view.jsx");
